
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/researchers",
      function () {
        return require("private-next-pages/researchers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/researchers"])
      });
    }
  